<template>
    <div class="panel-container show">
        <div class="panel-content">
            <div class="d-flex flex-column align-items-center justify-content-center p-4">
                <h5 class="mb-0 fw-700 text-center mt-3" v-if="this.location.id > 0">
                    {{this.location.title}}
                </h5>

                <h5 class="mb-0 fw-700 text-center mt-3" v-else>
                    {{__t("NEW_REST")}}
                </h5>
            </div>
            <div>
                <div class="form-group mt-2">
                    <label class="form-label" for="advanced_name">
                        {{__t("REST_NAME")}}
                    </label>

                    <div class="input-group flex-nowrap">
                        <div class="input-group-prepend">
							<span class="input-group-text">
								<i class="fal  fa-typewriter fs-xl" ></i>
							</span>
                        </div>
                        <input id="advanced_name" type="text" class="form-control" v-model="location.title">
                    </div>
                </div>

                <!-- Location PARAMS -->
                <div class="panel-tag mt-2">
                    {{__t("WOLT_LOCATION_PARAMS")}}
                </div>


                <div class="choose_type pb-4">
                    <yes_no
                        key="WOLT_TYPE"
                        v-model="location.general_fields.is_oauth"
                        :radio_options="radio_options"
                        title="WOLT_TYPE">

                    </yes_no>
                </div>

                <div class="form-group mt-2" v-for="general_field in general_fields">
                    <label class="form-label" >

                        {{get_wolt_param_name(general_field.title)}}
                    </label>

                    <div class="input-group flex-nowrap">
                        <div class="input-group-prepend">
							<span class="input-group-text">
								<i class="fal  fa-typewriter fs-xl" ></i>
							</span>
                        </div>
                        <input :disabled="is_oauth" :id="general_field.key" type="text" class="form-control" v-model="location.general_fields[general_field.key]">
                    </div>
                </div>


                <location_general_params :location="location"></location_general_params>

            </div>
        </div>
    </div>
</template>

<script>

import Location_general_params from "../../../base/location_general_tab/location_general_params.vue";
import Yes_no from "../../../../sys/radio/yes_no.vue";

export default {
    name: "wolt_general_tab",

    components : {
        Yes_no,
        Location_general_params,
    },

    props : {
        location : {
            type : Object
        }
    },


    methods : {

        get_wolt_param_name(type)
        {
            if(type.toUpperCase() == 'USERNAME') {
                  return 'MenuAPI Username';
            }

            if(type.toUpperCase() == 'TOKEN') {
                return 'MenuAPI Password';
            }

            if(type.toUpperCase() == 'ORDER_KEY') {
                return 'OrderAPI Key';
            }
            return type;
        },
    },
    computed: {

        radio_options() {

            

            return [
                {text: 'Standart',  value: false},
                {text: 'OAuth', value: true},
            ];
        },

        is_oauth() {

            if(this.location.hasOwnProperty("general_fields")) {
                if(this.location.general_fields.hasOwnProperty('is_oauth')) {
                    return this.location.general_fields.is_oauth;
                }
            }

            return false;
        },


        general_fields() {

            if(this.location.hasOwnProperty("general_fields")) {
                let res = [];
                for (const [key, value] of Object.entries(this.location.general_fields)) {
                    if (key !== 'id' && key !== 'is_oauth') {
                        res.push({
                            key: key,
                            value: value,
                            title: this.__t(key.toUpperCase())
                        });
                    }
                }

                return res;
            }
            return [];
        },

    }
}
</script>

<style scoped>

</style>
